/**
 * Navigation Setup Hook
 * Sets up the navigation utility with React Router's navigate function
 * This allows non-React code (like API interceptors) to trigger navigation
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setNavigate, clearNavigate } from "@/utils/navigation";

/**
 * Hook to set up the navigation utility
 * Call this in a component that has access to React Router context (like App)
 */
export function useNavigationSetup(): void {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);

    return () => {
      clearNavigate();
    };
  }, [navigate]);
}

export default useNavigationSetup;
